var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pivot',{key:_vm.pivotKey,ref:"cmpPivotData",staticClass:"sa-pivot-edit",attrs:{"width":"100%","height":"100%","toolbar":"","report":_vm.reportJson,"beforetoolbarcreated":_vm.customizeToolbar,"reportcomplete":_vm.onReportComplete}})}
var staticRenderFns = []

export { render, staticRenderFns }